/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React from 'react';
import { DataContextProvider } from '@forge/data-connector';
import { Card } from '@scuf/common';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import IEnergyManagementProps from '../../IEnergyManagementProps';
import EnergyOptimizationComponent from './EnergyOptimizationComponent';
import './EOtheme-combined.scss';

interface IEmaasEnergyOptimizationSiteWidget extends IEnergyManagementProps {
  mainGraph?: boolean;
  isAllUtility?: boolean;
}

const EnergyOptimizationSiteWidget = (
  props: IEmaasEnergyOptimizationSiteWidget
) => {
  const {
    bearerToken,
    requestContext,
    connectorConfig,
    mainGraph,
    isAllUtility
  } = props;
  const [t] = useTranslation();
  const d = descriptors.energyManagement;

  return (
    <DataContextProvider config={connectorConfig}>
      <div className="energy-optimization-widget kpi-card-common">
        <Card className="kpi-container-card-EnergyOptimization">
          <Card.Header className="kpi-header-container">
            <div className="kpi-card-title">
              {mainGraph && t(d.ENERGYOPTIMIZATIONNEW)}
            </div>
          </Card.Header>
          <EnergyOptimizationComponent
            requestContext={requestContext}
            bearerToken={bearerToken}
            mainGraph={mainGraph}
            isAllUtility={isAllUtility}
          />
        </Card>
      </div>
    </DataContextProvider>
  );
};
export default EnergyOptimizationSiteWidget;
